export default __webpack_public_path__ + "static/media/battery-circular-saw.d161156d.svg";